import { useUser } from "./data/firebase/use-user";
import { ComponentProps } from "react";

export const WithUser = ({ children }: ComponentProps<any>) => {
  const { user } = useUser();

  if (!user) return null;
  return children;
};
